export enum EWeightUnit {
    Gram = 'g',
    Kilogram = 'kg',
    Ton = 't',
}
export const convertWeight = (value: number, fromUnit: EWeightUnit, toUnit: EWeightUnit): number => {
    const weightInGrams = (() => {
        switch (fromUnit) {
            case EWeightUnit.Gram:
                return value;
            case EWeightUnit.Kilogram:
                return value * 1_000;
            case EWeightUnit.Ton:
                return value * 1_000_000;
        }
    })();

    switch (toUnit) {
        case EWeightUnit.Gram:
            return weightInGrams;
        case EWeightUnit.Kilogram:
            return weightInGrams / 1_000;
        case EWeightUnit.Ton:
            return weightInGrams / 1_000_000;
    }
};
